module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-about",
    class: _vm.displayedClass
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-about__content"
  }, [_c('p', [_vm._v("\n        Hey ! I’m Théo Kleman, a 20 years old web developer based in Paris.\n        "), _c('br'), _vm._v("\n        Currently in fourth year "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.hetic.net/"
    }
  }, [_vm._v("@hetic")]), _vm._v(", I also work as a freelancer !\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "last"
  }, [_vm._v("\n        I’ve worked for a few clients, for which I used lovely stacks composed of ReactJS, VueJS, AngularJS, Sass, Webpack & Gulp.\n        "), _c('br'), _vm._v("\n        I'm also familiar with ES6. I'm currently learning WebGL stuff. You can also download "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "./static/cv-theokleman.pdf"
    }
  }, [_vm._v("my resume")]), _vm._v(" !\n      ")]), _vm._v(" "), _c('span', [_vm._v("\n        If you have something you want to discuss, feel free to contact me :)\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "c-about__content__socials"
  }, [_c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://twitter.com/Theo_KlMan"
    }
  }, [_vm._v("twitter")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://fr.linkedin.com/in/theokleman"
    }
  }, [_vm._v("linkedin")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://github.com/TheoKleman/"
    }
  }, [_vm._v("github")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://codepen.io/theElkman/"
    }
  }, [_vm._v("codepen")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "mailto:theokleman.com"
    }
  }, [_vm._v("mail")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1eecd200!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About/About.vue
// module id = 87
// module chunks = 2